import { LayoutDimension } from "./types";

export const httpStatusOptions = ["1XX", "2XX", "3XX", "4XX", "5XX"] as const;

export const defaultLayoutDimensions: LayoutDimension = {
  left: 0,
  right: 0,
  top: 3,
  bottom: 19,
  height: 300,
  ticksLeft: 5
};
